<template>
    <p-search-screen
        title="Auto-Gen Records"
        api-destination="purchaseorderautogen"
        :filters="filters"
        :fields="fields"
        edit-key="id"
        :filter-by="['Description']"
        ref="searchScreen"
        add-new-button
    />
</template>
<script>
import { dateFormatter } from '../../components/Common/Formatters.js';
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';

export default {
    mixins: [SearchStorage],
    data() {
        return {
            filterName: 'AutogenFilter',
            filters: {
                automatic: "",
                perPage: 100,
                sortBy: 'lastGenerateDate',
                sortDesc: true
            },
            fields: [
                {
                    key: 'description',
                    label: 'Description',
                    sortable: true
                },
                {
                    key: 'lastGenerateDate',
                    label: 'Last Generated Date',
                    sortable: true,
                    formatter: dateFormatter
                }
            ]
        };
    }
};
</script>
